import { action, observable } from 'mobx';

import type { Result } from '../../confirmation';
import type { AlertResult, IAlertCall } from '../controls/alert';
import type { ErrorResult, IErrorCall } from '../controls/error';
import type { ISaveCheckCall, SaveCheckResult } from '../controls/save-check';
import type { IYesNoCall, YesNoResult } from '../controls/yesno';
import type { IYesNoCancelCall, YesNoCancelResult } from '../controls/yesnocancel';

export enum DialogType {
  alert,
  error,
  yesno,
  yesnocancel,
  saveCheck
}

type TDialogProps = IAlertCall | IErrorCall | IYesNoCall | IYesNoCancelCall | ISaveCheckCall;

export { Result } from '../../confirmation';

export class Store {
  @observable show: boolean = false;

  @observable props?: TDialogProps;

  @observable type?: DialogType;

  completed: boolean = false;
  promise?: Promise<Result>;
  resolve: (value?: Result | PromiseLike<Result> | undefined) => void = () => null;
  reject: (reason?: any) => void = () => null;

  /**
   * @deprecated [chris hunter] - this has been depreciated and should no longer be used
   */
  open(type: DialogType.alert, props: IAlertCall): Promise<AlertResult>;
  /**
   * @deprecated [chris hunter] - this has been depreciated and should no longer be used
   */
  open(type: DialogType.error, props: IErrorCall): Promise<ErrorResult>;
  /**
   * @deprecated [chris hunter] - this has been depreciated and should no longer be used
   */
  open(type: DialogType.yesno, props: IYesNoCall): Promise<YesNoResult>;
  /**
   * @deprecated [chris hunter] - this has been depreciated and should no longer be used
   */
  open(type: DialogType.yesnocancel, props: IYesNoCancelCall): Promise<YesNoCancelResult>;
  /**
   * @deprecated [chris hunter] - this has been depreciated and should no longer be used
   */
  open(type: DialogType.saveCheck): Promise<SaveCheckResult>;
  /**
   * @deprecated [chris hunter] - this has been depreciated and should no longer be used
   */
  open(type: DialogType.saveCheck, props: ISaveCheckCall): Promise<SaveCheckResult>;
  /**
   * @deprecated [chris hunter] - this has been depreciated and should no longer be used
   */
  @action.bound
  open(type: DialogType, props: TDialogProps = {}): Promise<Result> {
    if (!!this.promise && !this.completed) {
      this.reject();
    }

    this.show = true;
    this.type = type;
    this.props = props;

    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });

    return this.promise;
  }

  @action.bound
  complete(result: Result): void {
    this.completed = true;
    this.show = false;

    this.resolve(result);
  }

  @action.bound
  forceClose(): void {
    this.completed = true;
    this.show = false;
    this.reset();
    this.reject();
  }

  @action.bound
  reset(): void {
    this.type = null;
    this.props = null;
  }
}

export default new Store();
